export const TYPES = {
  SET_TASK_EFFORT_ALL: "task_effort/SET_TASK_EFFORT_ALL",
  SET_TASK_EFFORT_OPEN_ADD: "task_effort/SET_TASK_EFFORT_OPEN_ADD",
  SET_TASK_EFFORT_OPEN_EDIT: "task_effort/SET_TASK_EFFORT_OPEN_EDIT",
  SET_TASK_EFFORT_SELECTED: "task_effort/SET_TASK_EFFORT_SELECTED",
  SET_TASK_EFFORT_SEARCH: "task_effort/SET_TASK_EFFORT_SEARCH",
  //
  SET_TASK_EFFORT_COUNT_PASS: "task_effort/SET_TASK_EFFORT_COUNT_PASS",
  SET_TASK_EFFORT_COUNT_WARN: "task_effort/SET_TASK_EFFORT_COUNT_WARN",
  SET_TASK_EFFORT_COUNT_DENY: "task_effort/SET_TASK_EFFORT_COUNT_DENY",
  SET_TASK_EFFORT_SUM_EXP: "task_effort/SET_TASK_EFFORT_SUM_EXP",
  SET_TASK_EFFORT_SUM_EFFORT: "task_effort/SET_TASK_EFFORT_SUM_EFFORT",
  SET_TASK_EFFORT_SUM_EASE: "task_effort/SET_TASK_EFFORT_SUM_EASE",
  SET_TASK_EFFORT_SUM_MISTAKE: "task_effort/SET_TASK_EFFORT_SUM_MISTAKE",
};
